"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Term = void 0;
/**
 * This represents a single "term" object (ie. a single object in the terms columns of the EntitlementTerms table)
 */
class Term {
}
exports.Term = Term;
//# sourceMappingURL=pricing.interfaces.js.map